var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.541016,
    width: 13.9186,
    height: 13.9186,
    rx: 2,
    fill: "#1A4176"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14775 9.79845L2.79086 7.32522L1.98828 8.16149L5.14775 11.4769L11.9301 4.35971L11.1332 3.52344L5.14775 9.79845Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedboxIcon);
export default __webpack_public_path__ + "static/media/checkedbox-icon.9005f1a396619ea82da8c31a4440559d.svg";
export { ForwardRef as ReactComponent };